import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0831e0dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "extended-price-block" }
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PriceTable = _resolveComponent("PriceTable")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PriceTable, { "price-multiple-values": _ctx.priceMultipleValues }, null, 8, ["price-multiple-values"]),
      _createVNode(_component_BaseButton, {
        variant: "outline-primary",
        title: "Add item",
        onClick: _ctx.addElement
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Добавить цену ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}